import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { AuthContext } from '../../../context/auth';

import { BoughtMoviesModel } from '../../../pages/boughtMovies/query/types';
import { BigButton } from '../../UI/BigButton';

type BmButtonType = {
  movie: BoughtMoviesModel;
}

const BmButton:React.FC<BmButtonType> = ({movie}) => {
  const navigate = useNavigate();
  const { i18n: { language }} = useTranslation();
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  if (movie && movie.banner === 'blue-movie-plus' && !user.subscribed) {
    return (
      <BigButton
        sm={6}
        md={3}
        share
        onClick={() =>
          navigate(`/${language}/blue-movie-plus`, {
            state: { location: 'singleMovie' },
          })
        }
        icon="fa fa-share"
        text="Blue Movie Plus kaufen"
      />
    );
  }
};

export default BmButton